
import { i18nText } from '@/locales';
import { getModule, Module, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { ITableColumn } from '@/entity/table/table.types';

@Module({
    namespaced: true,
    name: 'tables',
    store,
    dynamic: true,
})
class TablesModule extends VuexModule {
    salonsColumns: ITableColumn[] = [
        {
            title: i18nText("Название"),
            dataIndex: 'name',
            key: '0',
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
        },
        {
            title: i18nText("Партнер"),
            dataIndex: 'partner[name]',
            key: '1',
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
            // sorter: (a: any, b: any) => a.partner.localeCompare(b.partner),
        },
        {
            title: i18nText("Город"),
            dataIndex: 'city[name]',
            key: '2',
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
            // sorter: (a: any, b: any) => a.city_name.localeCompare(b.city_name),
        },
        {
            title: i18nText("Менеджер"),
            dataIndex: 'manager[name]',
            key: '3',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'customRender',
            },
            // sorter: (a: any, b: any) => a.manager.localeCompare(b.manager),
            // onFilter: (value: any, record: any) =>
            //     record.manager.toString().toLowerCase().includes(value.toLowerCase()),
        },
        //todo
        // {
        //     title: 'Менеджер',
        //     dataIndex: 'manager',
        //     scopedSlots: {
        //         filterDropdown: 'filterDropdown',
        //         filterIcon: 'filterIcon',
        //         customRender: 'customRender',
        //     },
        //     sorter: (a: any, b: any) => a.manager.localeCompare(b.manager),
        //     onFilter: (value: any, record: any) =>
        //         record.manager
        //             .toString()
        //             .toLowerCase()
        //             .includes(value.toLowerCase()),
        // },
        {
            title: i18nText("Активность"),
            dataIndex: 'active',
            key: '4',
            
            // filters: [
            //     { text: 'Закрыта', value: 'closed' },
            //     { text: 'Заморожена', value: 'frozen' },
            //     { text: 'Открыта', value: 'opened' },
            //     { text: 'Запуск', value: 'progress' },
            // ],
            scopedSlots: {
                customRender: 'active',
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
            // onFilter: (value: any, record: any) => record.active.indexOf(value) === 0,
        },
        {
            title: i18nText("Дата открытия"),
            key: '5',
            dataIndex: 'opening_date',
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
        },
    ];
    // salonFinancesColumns: ITableColumn[] = [
    //     {
    //         title: 'Дата',
    //         dataIndex: 'date',
    //         key: 'date',
    //         scopedSlots: {
    //             customRender: "action_date"
    //         },
    //         sorter: (a: any, b: any) => {
    //             const date1 = new Date(a.date).getTime();
    //             const date2 = new Date(b.date).getTime();
    //             return date1 - date2;
    //         },
    //     },
    //     {
    //         title: 'Плательщик',
    //         dataIndex: 'author.name',
    //         key: 'author.name',
    //         sorter: (a: any, b: any) => a.payer.localeCompare(b.payer),
    //     },
    //     {
    //         title: 'Назначение',
    //         dataIndex: 'type[name]',
    //         key: 'type[name]',
    //         sorter: (a: any, b: any) => {
    //             alert();
    //             a.purpose.localeCompare(b.purpose)
    //         },
    //     },
    //     {
    //         title: 'Касса',
    //         dataIndex: 'cashbox[name]',
    //         key: 'cashbox[name]',
    //         sorter: (a: any, b: any) => a.kassa.localeCompare(b.kassa),
    //     },
    //     {
    //         title: 'Сумма, ₽',
    //         dataIndex: 'sum',
    //         key: 'sum',
    //         sorter: (a: any, b: any) => a.sum - b.sum,
    //     },
    //     {
    //         title: 'Услуга',
    //         dataIndex: 'service',
    //         key: 'service',
    //         sorter: (a: any, b: any) => a.service.localeCompare(b.service),
    //     },
    //     {
    //         title: 'Визит',
    //         dataIndex: 'visit[date]',
    //         key: 'visit[date]',
    //         scopedSlots: {
    //             customRender: 'visit'
    //         },
    //         sorter: (a: any, b: any) => {
    //             const date1 = new Date(a.visit).getTime();
    //             const date2 = new Date(b.visit).getTime();
    //             return date1 - date2;
    //         },
    //     },
    // ];
    salonClientsColumns: ITableColumn[] = [
        {
            title: i18nText("Имя"),
            dataIndex: 'name',
            key: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        },
        {
            title: i18nText("Телефон"),
            key: 'phone',
            dataIndex: 'phone',
        },
        {
            title: i18nText("Продано"),
            dataIndex: 'sold',
            key: 'sold',
            sorter: (a: any, b: any) => a.sold - b.sold,
        },
        {
            title: i18nText("Визиты"),
            dataIndex: 'visit',
            key: 'visit',
            sorter: (a: any, b: any) => a.visit - b.visit,
        },
        {
            title: i18nText("Скидка"),
            dataIndex: 'sale',
            key: 'sale',
            sorter: (a: any, b: any) => a.sale - b.sale,
        },
        {
            title: i18nText("Последний визит"),
            dataIndex: 'dateLast',
            key: 'dateLast',
            sorter: (a: any, b: any) => {
                const date1 = new Date(a.dateLast).getTime();
                const date2 = new Date(b.dateLast).getTime();
                return date1 - date2;
            },
        },
        {
            title: i18nText("Следующий визит"),
            dataIndex: 'dateNext',
            key: 'dateNext',
            sorter: (a: any, b: any) => {
                const date1 = new Date(a.dateNext).getTime();
                const date2 = new Date(b.dateNext).getTime();
                return date1 - date2;
            },
        },
    ];
    salonWorkersColumns: ITableColumn[] = [
        {
            title: i18nText("ФИО"),
            dataIndex: 'fio',
            key: 'fio',
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
            // sorter: (a: any, b: any) => a.fio.localeCompare(b.fio),
        },
        {
            title: i18nText("Телефон"),
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: i18nText("Должность"),
            dataIndex: 'position_name',
            key: 'position_name',
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
            // sorter: (a: any, b: any) => a.position.localeCompare(b.position),
        },
        {
            title: i18nText("Дата рождения"),
            dataIndex: 'birth_date',
            key: 'birth_date',
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
            // sorter: (a: any, b: any) => {
            //     const date1 = new Date(a.dateOfBirth).getTime();
            //     const date2 = new Date(b.dateOfBirth).getTime();
            //     return date1 - date2;
            // },
        },
        {
            title: i18nText("Статус"),
            dataIndex: 'status_name',
            key: 'status_name',
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
                customRender: 'status'
            },
            // sorter: (a: any, b: any) => a.status.localeCompare(b.status),
        },
        {
            title: i18nText("Категория"),
            dataIndex: 'category_name',
            key: 'category_name',
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
            // sorter: (a: any, b: any) => a.category.localeCompare(b.category),
        },
        {
            title: i18nText("Действия"),
            dataIndex: 'id',
            key: 'id',
            scopedSlots: {
                //filterDropdown: "filterDropdown",
                //filterIcon: "filterIcon",
                customRender: 'action'
            },
        },
    ];
    salonDocsColumns: ITableColumn[] = [
        {
            title: i18nText("Название"),
            dataIndex: 'name',
            key: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        },
        {
            title: i18nText("Размер"),
            key: 'amount',
            dataIndex: 'amount',
        },
        {
            title: i18nText("Дата"),
            dataIndex: 'date',
            key: 'date',
            sorter: (a: any, b: any) => {
                const date1 = new Date(a.date).getTime();
                const date2 = new Date(b.date).getTime();
                return date1 - date2;
            },
        },
        {
            title: i18nText("Действия"),
            dataIndex: 'action',
            key: 'action',
            scopedSlots: { customRender: 'action' },
        },
    ];
    workerTasksColumns: ITableColumn[] = [
        {
            title: i18nText("Филиал"),
            dataIndex: 'filial',
            key: 'filial',
            sorter: (a: any, b: any) => a.filial.localeCompare(b.filial),
            filters: [
                { text: 'Text1', value: '' },
                { text: 'Text2', value: '' },
            ],
        },
        {
            title: i18nText("Название"),
            dataIndex: 'name',
            key: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        },
        {
            title: i18nText("Клиент"),
            dataIndex: 'client',
            key: 'client',
            sorter: (a: any, b: any) => a.client.localeCompare(b.client),
        },
        {
            title: i18nText("Статус"),
            dataIndex: 'status',
            key: 'status',
            sorter: (a: any, b: any) => a.status.localeCompare(b.status),
        },
        {
            title: i18nText("Срок"),
            dataIndex: 'term',
            key: 'term',
            sorter: (a: any, b: any) => a.term.localeCompare(b.term),
        },
        {
            title: i18nText("Дата создания"),
            dataIndex: 'date',
            key: 'date',
            sorter: (a: any, b: any) => {
                const date1 = new Date(a.date).getTime();
                const date2 = new Date(b.date).getTime();
                return date1 - date2;
            },
        },
    ];
    clientsColumns: ITableColumn[] = [
        {
            title: i18nText("Имя"),
            key: 'name',
            dataIndex: 'name', // todo test name
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),

            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'customRender',
            },
        },
        {
            title: i18nText("Номер телефона"),
            key: 'phone',
            dataIndex: 'phone',
        },
        {
            title: i18nText("Посещений"),
            key: 'visited',
            dataIndex: 'visited',
            sorter: (a: any, b: any) => a.visited.localeCompare(b.visited),
        },
        {
            title: i18nText("Продано"),
            key: 'sold',
            dataIndex: 'sold',
            sorter: (a: any, b: any) => a.sold.localeCompare(b.sold),
        },
        {
            title: i18nText("Последний визит"),
            key: 'last_visit',
            dataIndex: 'last_visit',
            sorter: (a: any, b: any) => a.last_visit.localeCompare(b.last_visit),
        },
        {
            title: i18nText("Дата регистрации"),
            key: 'data_reg',
            dataIndex: 'data_reg',
            sorter: (a: any, b: any) => a.data_reg.localeCompare(b.data_reg),
        },
    ];
    
    clientsVisitColumnsForOwner: ITableColumn[] = [
        {
            title: i18nText("Дата визита"),
            key: 'data_visit',
            dataIndex: 'data_visit',
            sorter: (a: any, b: any) => a.data_visit.localeCompare(b.data_visit),
        },
        {
            title: i18nText("Позиция"),
            key: 'pos',
            dataIndex: 'pos',
            sorter: (a: any, b: any) => a.pos.localeCompare(b.pos),
        },
        {
            title: i18nText("Косметолог"),
            key: 'cosmetolog',
            dataIndex: 'cosmetolog',
            sorter: (a: any, b: any) => a.cosmetolog.localeCompare(b.cosmetolog),
        },
        {
            title: i18nText("Тип"),
            key: 'type',
            dataIndex: 'type',
        },
        {
            title: i18nText("Цена"),
            key: 'price',
            dataIndex: 'price',
            sorter: (a: any, b: any) => a.price.localeCompare(b.price),
        },
        {
            title: i18nText("Скидка"),
            key: 'sale',
            dataIndex: 'sale',
            sorter: (a: any, b: any) => a.sale.localeCompare(b.sale),
        },
        {
            title: i18nText("Итого"),
            key: 'all',
            dataIndex: 'all',
            sorter: (a: any, b: any) => a.all.localeCompare(b.all),
        },
    ];
    

    clientsTasksColumns: ITableColumn[] = [
        {
            title: i18nText("Студия"),
            dataIndex: 'studio',
            sorter: (a: any, b: any) => a.studio.localeCompare(b.studio),
        },
        {
            title: i18nText("Название"),
            dataIndex: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        },
        {
            title: i18nText("Статус"),
            dataIndex: 'status',
            sorter: (a: any, b: any) => a.status.localeCompare(b.status),
        },
        {
            title: i18nText("Важная"),
            dataIndex: 'important',
        },
        {
            title: i18nText("Срок"),
            dataIndex: 'term',
            sorter: (a: any, b: any) => a.term.localeCompare(b.term),
        },
        {
            title: i18nText("Дата создания"),
            dataIndex: 'date_create',
            sorter: (a: any, b: any) => a.date_create.localeCompare(b.date_create),
        },
    ];
    clientsDocumentsColumns: ITableColumn[] = [
        {
            title: i18nText("Название"),
            dataIndex: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        },
        {
            title: i18nText("Размер"),
            dataIndex: 'size',
            sorter: (a: any, b: any) => a.size.localeCompare(b.size),
        },
        {
            title: i18nText("Дата"),
            dataIndex: 'date',
            sorter: (a: any, b: any) => a.date.localeCompare(b.date),
        },
        {
            title: i18nText("Действия"),
            dataIndex: 'action',
        },
    ];
    clientsLoyaltyMemberColumns: ITableColumn[] = [
        {
            title: i18nText("Номер"),
            dataIndex: 'code',
        },
        {
            title: i18nText("Тип"),
            dataIndex: 'type',
        },
        {
            title: i18nText("Номинал"),
            dataIndex: 'nominalo',
        },
        {
            title: i18nText("Дата активации"),
            dataIndex: 'dateActive',
        },
        {
            title: i18nText("Дата сгорания"),
            dataIndex: 'dateDead',
        },
        {
            title: i18nText("Статус"),
            dataIndex: 'status',
        },
    ];
    clientsLoyaltyCertColumns: ITableColumn[] = [
        {
            title: i18nText("Код"),
            dataIndex: 'code',
        },
        {
            title: i18nText("Тип"),
            dataIndex: 'type',
        },
        {
            title: i18nText("Номинал"),
            dataIndex: 'nominalo',
        },
        {
            title: i18nText("Дата активации"),
            dataIndex: 'dateActive',
        },
        {
            title: i18nText("Дата сгорания"),
            dataIndex: 'dateDead',
        },
        {
            title: i18nText("Статус"),
            dataIndex: 'status',
        },
    ];
    loyaltyBonus: ITableColumn[] = [
        {
            title: i18nText("Название типа"),
            dataIndex: 'bonus_programm_type_id',
        },
        {
            title: i18nText("ФИО клиента"),
            dataIndex: 'client_name',
        },
        {
            title: i18nText("Номер телефона"),
            dataIndex: 'phone',
        },
        {
            title: i18nText("Скидка"),
            dataIndex: 'sale',
        },
        {
            title: i18nText("Комментарий"),
            dataIndex: 'comment',
        },
    ];
    loyaltyBonusType: ITableColumn[] = [
        {
            title: i18nText("Название типа"),
            dataIndex: 'name',
        },
        {
            title: i18nText("Доступная скидка"),
            dataIndex: 'available_discount',
        },
        {
            title: i18nText("Комментарий"),
            dataIndex: 'comment',
        },
    ];
    loyaltyCert: ITableColumn[] = [
        {
            title: i18nText("Код"),
            dataIndex: 'code',
        },
        {
            title: i18nText("Клиент"),
            dataIndex: 'client_name',
        },
        {
            title: i18nText("Тип"),
            dataIndex: 'type',
        },
        {
            title: i18nText("Номинал"),
            dataIndex: 'balance',
        },
        {
            title: i18nText("Дата активации"),
            dataIndex: 'active_form',
        },
        {
            title: i18nText("Дата сгорания"),
            dataIndex: 'active_to',
        },
        {
            title: i18nText("Статус"),
            dataIndex: 'status',
        },
    ];
    loyaltyCertType: ITableColumn[] = [
        {
            title: i18nText("Название"),
            dataIndex: 'name',
        },
        {
            title: i18nText("Выпущено"),
            dataIndex: 'created',
        },
    ];
    loyaltyStock: ITableColumn[] = [
        {
            title: i18nText("Название акции"),
            dataIndex: 'name',
        },
        {
            title: i18nText("Услуги"),
            dataIndex: 'service',
        },
        {
            title: i18nText("Скидка, %"),
            dataIndex: 'discount',
        },
        {
            title: i18nText("Период действия скидки"),
            dataIndex: 'active_to',
        },
        {
            title: i18nText("Дни"),
            dataIndex: 'days',
        },
        {
            title: i18nText("Часы"),
            dataIndex: 'active_from',
        },
    ];
    loyaltySubscriptionType: ITableColumn[] = [
        {
            title: i18nText("Название "),
            dataIndex: 'name',
            scopedSlots: {
                customRender: 'name'
            }
        },
        {
            title: i18nText("Выпущено"),
            dataIndex: 'created',
        },
    ];
    loyaltySubscription: ITableColumn[] = [
        {
            title: '',
            dataIndex: 'edit'
        },
        {
            title: i18nText("Номер"),
            dataIndex: 'id',
        },
        {
            title: i18nText("Тип"),
            dataIndex: 'type.name',
        },
        {
            title: i18nText("Баланс"),
            dataIndex: 'client.debt',
        },
        {
            title: i18nText("Статус"),
            dataIndex: 'status',
        },
        {
            title: i18nText("Действует до"),
            dataIndex: 'created_at',
        },
        {
            title: i18nText("Покупатель"),
            dataIndex: 'phone',
        },
        {
            title: i18nText("Продажа"),
            dataIndex: 'updated_at',
        },
        {
            title: i18nText("Стоимость"),
            dataIndex: 'type.price',
        },
        {
            title: i18nText("Списания"),
            dataIndex: 'client.sold',
        },
        {
            title: i18nText("Сумма"),
            dataIndex: 'discount',
        },
    ];
    workerNotesColumns: ITableColumn[] = [
        {
            title: i18nText("Студия"),
            dataIndex: 'studio',
            sorter: (a: any, b: any) => a.studio.localeCompare(b.studio),
            filters: [
                // { text: 'Text1', value: '' },
                // { text: 'Text2', value: '' },
            ],
        },
        {
            title: i18nText("Клиент"),
            dataIndex: 'client',
            sorter: (a: any, b: any) => a.client.localeCompare(b.client),
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'customRender',
            },
            onFilter: (value: any, record: any) => record.client.toString().toLowerCase().includes(value.toLowerCase()),
        },
        {
            title: i18nText("Создал"),
            dataIndex: 'created',
            sorter: (a: any, b: any) => a.created.localeCompare(b.created),
            filters: [
                // { text: 'Text1', value: '' },
                // { text: 'Text2', value: '' },
            ],
        },
        {
            title: i18nText("Услуга"),
            dataIndex: 'service',
            sorter: (a: any, b: any) => a.service.localeCompare(b.service),
            filters: [
                // { text: 'Text1', value: '' },
                // { text: 'Text2', value: '' },
            ],
        },
        // {
        //     title: 'Тип',
        //     dataIndex: 'type',
        //     filters: [
        //         { text: 'Text1', value: '' },
        //         { text: 'Text2', value: '' },
        //     ],
        // },
        {
            title: i18nText("Статус визита"),
            dataIndex: 'status',
            key: 'status',
            scopedSlots: { customRender: 'status' },
            filters: [
                // { text: 'Text1', value: '' },
                // { text: 'Text2', value: '' },
            ],
        },
        {
            title: i18nText("Дата визита"),
            dataIndex: 'date',
            sorter: (a: any, b: any) => {
                const date1 = new Date(a.date).getTime();
                const date2 = new Date(b.date).getTime();
                return date1 - date2;
            },
        },
    ];
    workerServicesColumns: ITableColumn[] = [
        {
            title: i18nText("Название"),
            dataIndex: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'customRender',
            },
            onFilter: (value: any, record: any) => record.name.toString().toLowerCase().includes(value.toLowerCase()),
        },
        {
            title: '',
            width: '10%',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    workerFilesColumns: ITableColumn[] = [
        {
            title: i18nText("Название"),
            dataIndex: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        },
        {
            title: i18nText("Размер"),
            dataIndex: 'amount',
        },
        {
            title: i18nText("Дата"),
            dataIndex: 'date',
            sorter: (a: any, b: any) => {
                const date1 = new Date(a.date).getTime();
                const date2 = new Date(b.date).getTime();
                return date1 - date2;
            },
        },
        {
            title: i18nText("Действия"),
            dataIndex: 'action',
            width: '30%',
            scopedSlots: { customRender: 'action' },
        },
    ];

    servicesExtColumns: ITableColumn[] = [
        {
            dataIndex: "name",
            key: "name",
            slots: { title: "customTitle" },
            scopedSlots: { customRender: "service_name" },
            width: "40%",
        },
        {
            title: "",
            dataIndex: "service_duration",
            key: "service_duration",
            scopedSlots: { customRender: "service_duration" },
            width: "55%",
        },
        {
            title: "",
            dataIndex: "action",
            scopedSlots: { customRender: "action" },
            width: "5%",
        },
        {
            title: "",
            dataIndex: "delete",
            scopedSlots: { customRender: "delete" },
            width: "5%",
        },
    ];
    servicesCategoryColumns: ITableColumn[] = [
        {
            title: i18nText("Название"),
            dataIndex: "name",
            key: "name",
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
        },
        /*{
            title: "Детали услуг",
            dataIndex: "online_appointment_name",
            key: "online_appointment_name",
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
        },*/
        {
            title: i18nText("Услуг"),
            dataIndex: "contain_services",
            key: "contain_services",
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
        },
        {
            title: "",
            dataIndex: "action",
            key: 'action',
            scopedSlots: {
                customRender: "action"
            },
        },
    ];
    servicesCategoryColumnsPartner: ITableColumn[] = [
        {
            title: i18nText("Название"),
            dataIndex: "name",
            key: "name",
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
        },
        /* {
            title: "Детали услуги",
            dataIndex: "online_appointment_name",
            key: "online_appointment_name",
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
        }, */
        {
            title: i18nText("Услуг"),
            dataIndex: "contain_services",
            key: "contain_services",
            scopedSlots: {
                filterDropdown: "filterDropdown",
                filterIcon: "filterIcon",
            },
        },
        {
            title: "",
            dataIndex: "delete",
            key: 'delete',
            scopedSlots: { customRender: "delete" },
        },
    ];
    servicesColumns: ITableColumn[] = [
        {
            title: '#',
            dataIndex: 'data.id',
            key: 'id',
        },
        {
            title: '',
            dataIndex: 'name',
            key: 'name',
            // slots: { title: 'customTitle' },
            //scopedSlots: { customRender: 'customTitle' },
        },
        {
            title: '',
            dataIndex: 'price',
        },
        {
            title: '',
            dataIndex: 'price_2',
            scopedSlots: { customRender: 'titleLink' },
        },
        {
            title: '',
            dataIndex: 'service_duration',
            scopedSlots: { customRender: 'name_minuts' },
        },
        // {
        //     title: '',
        //     dataIndex: 'actios',
        //     key: 'operation',

        // },
    ];

    serviceWorkersColumns: ITableColumn[] = [
        {
            title: i18nText("Сотрудник"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("Категория"),
            dataIndex: 'category[name]',
            key: 'category[name]',
        },
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            scopedSlots: { customRender: 'action' },
        },
    ];

    serviceDetailWorkersColumns: ITableColumn[] = [
        {
            title: i18nText("Сотрудник"),
            dataIndex: 'name',
            key: 'name',
            scopedSlots: { customRender: 'last_name' },
        },
        {
            title: i18nText("Категория"),
            dataIndex: 'category_name',
            key: 'category_name',
        },
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            scopedSlots: { customRender: 'action' },
        },
    ];

    serviceDetailProductsColumns: ITableColumn[] = [
        {
            title: i18nText("Расходник"),
            dataIndex: 'product_name',
            key: 'name',
        },
        {
            title: i18nText("Склад"),
            dataIndex: 'store_name',
            key: 'store_name',
        },
        {
            title: i18nText("Кол-во"),
            dataIndex: 'quantity',
            key: 'quantity',
            scopedSlots: { customRender: 'quantity' },
        },
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            scopedSlots: { customRender: 'action' },
        },
    ];

    financeCounterparties: ITableColumn[] = [
        {
            title: i18nText("Название"),
            dataIndex: 'name',
            key: 'name',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'customRender',
            },
        },
        {
            title: i18nText("Контакты"),
            dataIndex: 'contact_person',
            key: 'contact_person',
            width: '20%',
            scopedSlots: {
                customRender: 'contact_person',
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
            },
        },
        {
            title: i18nText("Реквизиты"),
            dataIndex: 'requisites',
            key: 'requisites',
            scopedSlots: { 
                customRender: 'requisites',
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
            },
        },
        {
            title: i18nText("Адрес"),
            dataIndex: 'address',
            key: 'address',
            scopedSlots: { 
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
            },
        },
        {
            title: i18nText("Баланс"),
            dataIndex: 'balance',
            key: 'balance',
            scopedSlots: {
                customRender: 'balance',
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
            },
        },
    ];

    paymentArticles: ITableColumn[] = [
        {
            title: i18nText("Название"),
            dataIndex: 'name',
            key: 'name',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'name',
            },
            onFilter: (value, record) => record.name.toString().toLowerCase().includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: (visible) => {
                if (visible) {
                    console.log(visible, 'filterDropdownVisible');
                    /*setTimeout(() => {
                    this.searchInput.focus();
                  }, 0);*/
                }
            },
        },
        {
            title: i18nText("Тип статьи"),
            dataIndex: 'type_name',
            key: 'type_name',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'type',
            },
            onFilter: (value, record) => record.type.toString().toLowerCase().includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: (visible) => {
                if (visible) {
                    console.log(visible, 'filterDropdownVisible');
                    /*setTimeout(() => {
                    this.searchInput.focus();
                  }, 0);*/
                }
            },
        },
    ];

    financeOperations: ITableColumn[] = [
        {
            title: '№',
            dataIndex: 'id',
            key: 'id',
            width: '51px',
        },
        {
            title: i18nText("Дата"),
            dataIndex: 'date',
            key: 'date',
            width: '150px',
            scopedSlots: {
                customRender: 'date',
            },
        },
        {
            title: i18nText("Получатель"),
            dataIndex: 'target',
            key: 'target[name]',
            scopedSlots: {
                customRender: 'target',
            },
        },
        {
            title: i18nText("Назначение"),
            dataIndex: 'type[name]',
            key: 'type[name]',
        },
        {
            title: i18nText("Касса"),
            dataIndex: 'cashbox[name]',
            key: 'cashbox[name]',
        },
        {
            title: i18nText("Комментарий"),
            dataIndex: 'comment',
            key: 'comment',
            width: '138px',
        },
        {
            title: i18nText("Автор"),
            dataIndex: 'author[name]',
            key: 'author[name]',
        },
        {
            title: i18nText("Сумма"),
            dataIndex: 'sum',
            key: 'sum',
            width: '95px',
            scopedSlots: {
                customRender: 'sum',
            },
        },
        {
            title: i18nText("Остаток"),
            dataIndex: 'remainder',
            key: 'remainder',
            width: '95px',
            scopedSlots: {
                customRender: 'remainder',
            },
        },
        {
            title: i18nText("Визит"),
            dataIndex: 'visit[date]',
            key: 'visit[date]',
            width: '150px',
            scopedSlots: {
                customRender: 'visit',
            },
        },
    ];
    //TODO::Sales by Service for Reports Продажи по услугам
    ReportSalesbyServiceColumns: ITableColumn[] = [
        {
            title: i18nText("Услуга"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("Кол-во оказанных услуг"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("Оплачено скидкой"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("Оплачено со счетов клиентов"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("Оплачено деньгами"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("Стоимость расходников"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("ЗП Сотрудников"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("Прибыль"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("% от текущей выручки"),
            dataIndex: 'name',
            key: 'name',
        },
    ];

    ReportFinance: ITableColumn[] = [
        {
            title: i18nText("Доходы"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("формула"),
            dataIndex: 'description',
            key: 'description',
        }
    ];

    visitStatusColumns: ITableColumn[] = [
        {
            title: i18nText("Позиция"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("Кол-во"),
            dataIndex: 'count',
            key: 'count',
        },
        {
            title: i18nText("Цена, ₽"),
            dataIndex: 'price_first',
            key: 'price_first',
        },
        {
            title: i18nText("Скидка, %"),
            dataIndex: 'sale',
            key: 'sale',
        },
        {
            title: i18nText("Итог, ₽"),
            dataIndex: 'total_price',
            key: 'total_price',
        },
    ];

    vacancyColumns: ITableColumn[] = [
        {
            title: i18nText("Студия"),
            dataIndex: 'salon_name',
            key: 'salon_id',
        },
        {
            title: i18nText("Название вакансии"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: i18nText("ЗП"),
            dataIndex: 'salary',
            key: 'salary',
            scopedSlots: { customRender: 'salary' },
        }
    ];
}

export const TablesStore = getModule(TablesModule);
